module.exports = __webpack_public_path__ + "img/pvpstats.953617ee.png";